import React from 'react';
import './Title.css';

const Title = () => {
  return (
    <div className="title-container">
      <h1 className="title-name">Hadi Fawad                 </h1>
    </div>
  );
};

export default Title;
